/* Native details on mobile; all groups open on desktop. No-JS keeps every link visible. */
if (!customElements.get('mt-footer')) {
  customElements.define('mt-footer', class extends HTMLElement {
    connectedCallback() {
      this._mtFooterAbort?.abort();
      this._mtFooterAbort = new AbortController();
      const signal = this._mtFooterAbort.signal;
      const desktop = window.matchMedia('(min-width: 750px)');
      const groups = [...this.querySelectorAll('.mt-footer__details')];
      const sync = () => {
        groups.forEach(group => {
          // Keep a group open if a keyboard user is currently inside it during resize.
          group.open = desktop.matches || group.contains(document.activeElement);
        });
      };
      sync();
      desktop.addEventListener('change', sync, { signal });
      // Selecting a menu block in the Shopify editor reveals its links.
      this.addEventListener('shopify:block:select', event => {
        event.target.querySelector('.mt-footer__details')?.setAttribute('open', '');
      }, { signal });
    }
    disconnectedCallback() {
      this._mtFooterAbort?.abort();
    }
  });
}
